/**
 * 年度金额走势统计组件（柱状和曲线混合图）
 * zxw
 * 创建时间：2025-12-10
 */

import { useEffect } from 'react';
import { Chart } from '@antv/g2';
import { Skeleton } from 'antd';
import CNF from '../../incs/Config.js';
import { isMobileDevice } from '../../incs/FunHelper.js';

const ChartILYearAmount = props => {
    const { children, id, title, subtitle, streamStatus } = props;

    const timestamp = new Date().getTime().toString();
    const chartId = `${id ? id : 'antv-g2-id'}.${timestamp}`;

    // 加载中显示默认图片
    if (streamStatus === 'loading') {
        return <Skeleton.Image active={true} />;
    }

    useEffect(() => {
        const chart = new Chart({
            container: chartId,
            autoFit: isMobileDevice,
        });

        chart.title({
            title: title,
            subtitle: subtitle,
        });

        // 格式化数据
        chart.data(JSON.parse(children));

        chart
            .interval()
            .encode('x', 'year')
            .encode('y', 'amount')
            .axis('x', { title: '年份', })
            .axis('y', {
                title: '金额',
                // titleFill: CNF.swatches[CNF.currentSwatche][0],
                labelFormatter: (d) => `${d > 10000 ? (d / 10000).toFixed(2) + '万元' : d + '元'}`,
            })
            .animate('enter', {
                type: 'scaleInY',
                duration: CNF.animateDuration,
            },)
            .style('minWidth', 20)
            .style('maxWidth', 40)
            .tooltip({
                items: [(d => ({
                    name: '金额',
                    value: `${d.amount > 10000 ? (d.amount / 10000).toFixed(2) + '万元' : d.amount + '元'}`,
                }))],
            });

        chart
            .line()
            .encode('x', 'year')
            .encode('y', 'count')
            .encode('shape', 'smooth')
            .style('stroke', CNF.swatches[CNF.currentSwatche][2],)
            .style('lineWidth', 2)
            .scale('y', { independent: true })
            .axis('y', {
                position: 'right',
                grid: null,
                title: '数量',
                // titleFill: CNF.swatches[CNF.currentSwatche][2],
            })
            // .animate('enter', {
            //     type: 'pathIn',
            //     duration: CNF.animateDuration,
            // },)
            .tooltip({
                items: [(d => ({
                    name: '数量',
                    value: `${d.count}`,
                }))],
            });

        chart.render();

        return () => {
            chart.destroy();
        }
    }, []);

    return <div id={chartId}></div>
}

export default ChartILYearAmount;